import { CLP, formatDateTime } from "@/lib/format";
import { Badge } from "@/components/ui/badge";
import { MapPin, Gift } from "lucide-react";

export function TicketCard({ reservation: r, business }) {
  return (
    <div className="mx-auto max-w-sm text-left" data-testid={`ticket-${r.id}`}>
      <div className="rounded-2xl overflow-hidden border border-border shadow-[0_10px_40px_-12px_rgba(121,68,228,0.3)] bg-card">
        <div className="bg-primary text-primary-foreground p-5">
          <p className="text-xs uppercase tracking-widest opacity-80">VIVOTaller Ticket</p>
          <h3 className="font-display font-bold text-xl mt-1 leading-tight">{r.workshop_name}</h3>
          <p className="text-sm opacity-90 mt-1 capitalize">{formatDateTime(r.starts_at)}</p>
        </div>
        <div className="relative flex items-center">
          <div className="w-4 h-4 rounded-full bg-background -ml-2" />
          <div className="flex-1 border-t border-dashed border-border" />
          <div className="w-4 h-4 rounded-full bg-background -mr-2" />
        </div>
        <div className="p-5 flex gap-4 items-center">
          {r.qr_image && (
            <img src={r.qr_image} alt="QR" className="w-28 h-28 rounded-lg border border-border bg-white p-1" data-testid="ticket-qr" />
          )}
          <div className="text-sm space-y-1.5 flex-1">
            <p className="font-medium">{r.customer_name}</p>
            <p className="text-muted-foreground">{r.quantity} cupo{r.quantity > 1 ? "s" : ""} · {CLP(r.amount_clp)}</p>
            {business?.address && (
              <p className="text-muted-foreground flex items-center gap-1 text-xs">
                <MapPin className="w-3 h-3" />{business.address}
              </p>
            )}
            {r.es_regalo && r.gift && (
              <Badge variant="outline" className="gap-1"><Gift className="w-3 h-3" /> Regalo para {r.gift.recipient_name}</Badge>
            )}
            <p className="font-mono text-[10px] text-muted-foreground pt-1">{r.codigo_qr}</p>
          </div>
        </div>
        {business?.address && (
          <a href={`https://www.google.com/maps/search/${encodeURIComponent(business.address)}`}
            target="_blank" rel="noreferrer"
            className="block text-center text-sm font-medium text-primary border-t border-border py-3 hover:bg-secondary"
            data-testid="ticket-directions">
            Cómo llegar →
          </a>
        )}
      </div>
    </div>
  );
}
